module.exports = __webpack_public_path__ + "nlogo_transparent.png";